import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '../App.vue'
import Home from '../views/home.vue'


// Vue支持VueRouter
Vue.use(VueRouter)

let router = new VueRouter({
    
    routes: [
        { path: '*', redirect: '/home' },
        {
            path: '/home',
            component: Home
        },
    ]
})

new Vue({
    render: h => h(App),
    router
}).$mount('#app')       
